﻿export class TopicConstant {
    static fuseCoveragePageSystemName = "fuse-coverage";
    static сircuitBreakerCoverageSystemName = "circuit-breaker-coverage";
    static conflictMineralsSourcingPolicySystemName = "conflict-minerals-sourcing-policy";
}
